import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { AiOutlineClose } from 'react-icons/ai'

const ModalComponent = ({
  show,
  Title,
  className,
  onClick,
  Content,
  size,
  dialogClassName,
  Titleclassname,
  HeaderclassName,
  isTitle,
  backdrop,
  fullscreen
}) => {
  return (
    <div>
      <Modal dialogClassName={dialogClassName} show={show} size={size} centered backdrop={backdrop} fullscreen={fullscreen}>
        {isTitle ? (
          <div className={HeaderclassName}>
            <Modal.Header className={`d-flex justify-content-between align-items-center }`}>
              <Modal.Title>
                <div className={Titleclassname}>{Title}</div>
              </Modal.Title>
              <div>
                <AiOutlineClose size={25} className="cursor" onClick={onClick} />
              </div>
            </Modal.Header>
          </div>
        ) : null}
        <Modal.Body>
          <div className={`${className}`}>{Content}</div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

ModalComponent.defaultProps = {
  show: false,
  Title: '',
  onClick: () => {},
  Content: '',
  className: '',
  size: 'lg',
  dialogClassName: '',
  isTitle: true,
  backdrop: false,
  Titleclassname: ' ',
  HeaderclassName: ' ',
}

ModalComponent.propTypes = {
  show: PropTypes.bool,
  Title: PropTypes.string,
  className: PropTypes.string,
  Titleclassname: PropTypes.string,
  HeaderclassName: PropTypes.string,
  onClick: PropTypes.func,
  Content: PropTypes.node,
  size: PropTypes.string,
  dialogClassName: PropTypes.string,
  isTitle: PropTypes.bool,
  backdrop: PropTypes.bool,
  fullscreen:PropTypes.bool
}

export default ModalComponent
